import "./Sanctuary.module.css";
import Header from "@/reusable_sections/Header";
import TheAfterhoursPulse from "./sections/TheAfterhoursPulse";
import LiveFromTheAltar from "./sections/LiveFromTheAltar";
import TheSensoryExperience from "./sections/TheSensoryExperience";
import CuratedRituals from "./sections/CuratedRituals";
import RecentIndulgences from "./sections/RecentIndulgences";
import TheInnerCircle from "./sections/TheInnerCircle";
import GlobalTestimonials from "./sections/GlobalTestimonials";
import Footer from "@/reusable_sections/Footer";
export default function SanctuaryPage() {
  return <div>
      <Header />
      <TheAfterhoursPulse />
      <LiveFromTheAltar />
      <TheSensoryExperience />
      <CuratedRituals />
      <RecentIndulgences />
      <TheInnerCircle />
      <GlobalTestimonials />
      <Footer />
    </div>;
}